import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { Band, PullQuote } from './Band';
import { comparisonRows } from '../../data/site';
export function Positioning() {
  return <Band id="product" eyebrow="Assessment, not surveillance" title="Detection watches candidates. Lentic measures judgement." description="Detectors break on every model release, and they punish people for using the tools their job requires. The failure mode is a false accusation you then have to defend, against a candidate who did nothing wrong." aside={<PullQuote data-id="element-322" data-mp="308r4krer3vrc">
          We don't detect AI use. We assume it, supply it, and measure what the
          candidate does with what it gives them.
        </PullQuote>} data-id="element-321" data-mp="2makis9n2tm81">
      <div className="overflow-hidden rounded-2xl border border-mist bg-white/70" data-id="element-323" data-mp="3a0esiic3muo2">
        <table className="w-full border-collapse text-left" data-id="element-324" data-mp="3e2084bg0pn1y">
          <caption className="sr-only" data-id="element-325" data-mp="3dznkpirhqkhi">AI detection compared with Lentic</caption>
          <thead data-id="element-326" data-mp="3j1cvcxasww52">
            <tr className="border-b border-mist bg-bone/60" data-id="element-327" data-mp="3iyqrp8r170s4">
              <th scope="col" className="w-1/5 px-6 py-5" data-id="element-328" data-mp="2lj4wql4p2zdp">
                <span className="sr-only" data-id="element-329" data-mp="2hgi0m80zqsap">Dimension</span>
              </th>
              <th scope="col" className="px-6 py-5" data-id="element-330" data-mp="2hiky1d4h3npg">
                <span className="flex items-center gap-2 font-display text-lg font-medium text-muted" data-id="element-331" data-mp="2cigefe89qcv0">
                  <XIcon className="h-4 w-4 text-clay" aria-hidden="true" data-id="element-332" data-mp="27jc60pt64j5q" />
                  AI detection
                </span>
              </th>
              <th scope="col" className="px-6 py-5" data-id="element-333" data-mp="357voa0o75zpc">
                <span className="flex items-center gap-2 font-display text-lg font-medium text-ink" data-id="element-334" data-mp="30812gbja40b5">
                  <CheckIcon className="h-4 w-4 text-teal" aria-hidden="true" data-id="element-335" data-mp="2veyecix9tj2c" />
                  Lentic
                </span>
              </th>
            </tr>
          </thead>
          <tbody data-id="element-336" data-mp="3nwtz6a7q6c6t">
            {comparisonRows.map(row => <tr key={row.axis} className="border-b border-mist/70 last:border-0" data-id="element-337" data-mp="3nxvdqony9gta">
                <th scope="row" className="px-6 py-5 align-top font-mono text-xs uppercase tracking-[0.12em] text-teal" data-id="element-338" data-mp="3j4999jrxwj8k">
                  {row.axis}
                </th>
                <td className="px-6 py-5 align-top text-base leading-snug text-muted" data-id="element-339" data-mp="1la5464fp98lo">
                  {row.detection}
                </td>
                <td className="px-6 py-5 align-top text-base font-medium leading-snug text-ink" data-id="element-340" data-mp="17i8hifwsvqwo">
                  {row.lentic}
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
    </Band>;
}